<div class="modal-header border-b border-solid border-base-2 px-6 py-4">
    <h2 class="modal-title text-title-2 text-text-primary font-semibold">{{ data.title | translate }}</h2>
    <button
        type="button"
        class="btn btn-circle btn-ghost element-cancel"
        [attr.aria-label]="'accessibility.close-dialog' | translate"
        (click)="closeDialog()"
    ></button>
</div>
<div class="modal-body px-6 py-5">
    <p class="text-base text-text-primary">{{ data.body | translate }}</p>
</div>
<div class="modal-footer border-t border-solid border-base-2 px-6 py-4">
    <button
        class="btn btn-primary"
        type="button"
        [attr.aria-label]="'accessibility.close' | translate"
        (click)="closeDialog()"
    >
        {{ 'accessibility.close' | translate }}
    </button>
</div>
